



























import {Component, Prop, Vue} from "vue-property-decorator";
import axios from 'axios'
import * as XLSX from 'xlsx'
import {cloneWith} from "lodash";

@Component({
    components: {}
})
export default class IncomeImportFromFileModal  extends Vue {
    @Prop({
        required: false,
        default: null
    })
    private curRegion!: any;
    @Prop({
        required: false,
        default: null
    })
    private curMonth!: any;

    @Prop({
        required: false,
        default: false
    })
    private show!: any;


    @Prop({
        required: false,
        default: 0
    })
    private requestId!: any;

    @Prop({
        required: false,
        default: 2023
    })
    private curYear!: any;
    private curentRequest: any = {};

    private lastKat: number = -1;

    private tableTypeLocal: any = 1
    private selectedFile: any = null;
    private tableData: any[] = []
    private importedData: any[] = []
    private tableFields: any[] = [
        {label: "КАТЕГОРИЯ", key: "kat"},
        {
            key: 'cls',
            label: 'КЛАСС'
        },
        {
            key: 'pcl',
            label: 'ПОДКЛАСС'
        },
        {
            key: 'spf',
            label: 'СПЕЦИФИКА'
        },
        {label: "Cумма", key: "total"},
        {
            key: 'january',
            label: 'Январь'
        },
        {
            key: 'february',
            label: 'Февраль'
        },
        {
            key: 'march',
            label: 'Март'
        },
        {
            key: 'april',
            label: 'Апрель'
        },
        {
            key: 'may',
            label: 'Май'
        },
        {
            key: 'june',
            label: 'Июнь'
        },
        {
            key: 'july',
            label: 'Июль'
        },
        {
            key: 'august',
            label: 'Август'
        },
        {
            key: 'september',
            label: 'Сентябрь'
        },
        {
            key: 'october',
            label: 'Октябрь'
        },
        {
            key: 'november',
            label: 'Ноябрь'
        },
        {
            key: 'december',
            label: 'Декабрь'
        },
    ];

    private calcFields = [
        'plan',
        'january',
        'february',
        'march',
        'april',
        'may',
        'june',
        'july',
        'august',
        'september',
        'october',
        'november',
        'december'
    ]
    private showModal = false;
    private async created() {
        await this.loadLastKat()
        const that = this;
        this.$watch('showModal', () => {
            if (!this.showModal) this.resetModal()
        })
        this.$watch('show', function () {
            if (that.show) {
                that.showModal = that.show;
            }
            that.$emit('shown');
        })
        this.$watch('requestId', async function () {
            await this.updateRequest()
        });
    }
    private mounted() {}
    private resetModal() {
        this.tableData = [];
        this.importedData = []
        for (const key of Object.keys(this.importErrors)) {
            this.importErrors[key] = false
        }
        this.importErrors.duplicates = []
    }
    private importErrors:any = {
        incorrectRows: false,
        negativeValue: false,
        duplicationError: false,
        lastKatError: false,
        duplicates: []
    }
    private importFiles() {
        const resObj:any = {
            data: this.tableData,
            error: this.importErrors
        }
        this.$emit('importTableIncome', resObj)
        this.showModal = false;
        this.resetModal()
    }
    private async loadSpfDict(spfs: any[]) {
        const req = {
            year: this.curYear,
            spf_list: spfs
        }
        let dict:any = {}
        await axios.post('/api-py/dict-ebk-doh-spf-map', req).then(response => {
            dict = response.data
        })
        return dict
    }
    private parseFloatZero(input:any) {
        const rowN = input? input.toString().replace(',', '.'): 0
        const floatValue = parseFloat(rowN);
        return Number.isNaN(floatValue) ? 0 : floatValue;
    }
    private async updateRequest() {
        if (!this.requestId) {
            this.curentRequest = {
                region: this.curRegion
            }
            return;
        }
        await axios.get(`/api-py/import-file-request-id/${this.requestId}`).then(response => {
            this.curentRequest = response.data
        }).catch(error => {
            console.log(error)
            this.curentRequest = null
        })
    }
    private async getTalbeData() {
        const isRowEmpty = (row: any[]) => row.every(cell => cell === '' || cell === null || isNaN(cell));
        const spfs = []
        const preData = [];
        await this.updateRequest()
        for (const row of this.importedData) {
            if (isRowEmpty(row.slice(0, 4))) continue;
            try {
                const region = (this.curentRequest && this.curentRequest.region)? this.curentRequest.region: row[0]
                const katclspclspf:string = row[2].toString()
                const kat = parseInt(katclspclspf.slice(0, 1), 10)
                const cls = parseInt(katclspclspf.slice(1, 3), 10)
                const pcl = parseInt(katclspclspf.slice(3, 4), 10)
                const spf = parseInt(katclspclspf.slice(4, 6), 10)
                if (kat === this.lastKat) {
                    this.importErrors.lastKatError = true;
                    continue
                }
                let total = 0
                const spfObj = {
                    region: region,
                    kat: kat,
                    katName: '',
                    cls: cls,
                    clss: cls,
                    clssName: '',
                    pcl: pcl,
                    pclName: '',
                    spf: spf,
                    name_ru: '',
                    plan: 0,
                    plan_type: 1,
                    total: 0,
                    month: this.curMonth,
                    gr: null
                }
                preData.push(spfObj)
                spfs.push({
                    kat: kat,
                    cls: cls,
                    pcl: pcl,
                    spf: spf,
                })
                for (let i = 5; i < 17; i++) {
                    if (i-4 <this.curMonth) {
                        this.$set(spfObj, this.calcFields[i-5+1], 0);
                        this.$set(spfObj, 'month' + (i-5), 0);
                        this.$set(spfObj, 'month_' + (i-5), 0);
                    } else {
                        const value = this.parseFloatZero(row[i])
                        if (value < 0) this.importErrors.negativeValue = true
                        this.$set(spfObj, this.calcFields[i-5+1], value);
                        this.$set(spfObj, 'month' + (i-5), value);
                        this.$set(spfObj, 'month_' + (i-5), value);
                        total += value;
                    }
                }
                total = parseFloat(total.toFixed(1))
                spfObj.total = total;
                spfObj.plan = total
            } catch (e) {
                console.log(e)
            }
        }
        if (preData.length === 0) {
            this.makeToast('warning', 'Импорт Таблицы', 'Не найдено актуальных специфик по данным из файла')
            return
        }
        const spfDict:any = await this.loadSpfDict(spfs)
        if (Object.keys(spfDict).length === 0) {
            this.makeToast('warning', 'Импорт Таблицы', 'Не найдено актуальных специфик по данным из файла')
            return
        }
        const locale_i18 = 'name_' + this.$i18n.locale
        const newTable: any[] = [];
        const duplicates:string[] = [];
        for (let i = 0; i < preData.length; i++) {

            const new_item = Object.assign({}, preData[i])
            const spfKey = `${new_item.kat}_${new_item.cls}_${new_item.pcl}_${new_item.spf}`
            if (duplicates.includes(spfKey)) {
                this.importErrors.duplicationError = true;
                this.importErrors.duplicates.push(new_item)
            } else {
                duplicates.push(spfKey)
            }
            if (!spfDict[spfKey]) {
                this.importErrors.incorrectRows = true
                continue;
            }
            new_item.katName = spfDict[spfKey][`kat_${locale_i18}`]
            new_item.clssName = spfDict[spfKey][`cls_${locale_i18}`]
            new_item.pclName = spfDict[spfKey][`pcl_${locale_i18}`]
            new_item.name_ru = spfDict[spfKey][locale_i18]

            newTable.push(new_item)
        }
        this.tableData = newTable
        if (this.tableData.length === 0) {
            this.makeToast('warning', 'Импорт Таблицы', 'Не найдено актуальных специфик по данным из файла')
        }
    }
    private async handleFileInput (event:any) {
        this.tableData = []
        this.importedData = []
        this.selectedFile = null
        // Access the selected file from the event
        this.selectedFile = event.target.files[0];
        const reader = new FileReader();
        reader.onload = async (e: any) => {
            /* Parse data */
            const bstr = e.target.result;
            const wb = XLSX.read(bstr, {type: "binary"});
            /* Get first worksheet */
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            /* Convert array of arrays */
            const data = XLSX.utils.sheet_to_json(ws, {header: 1});
            this.importedData = data.slice(1)
            await this.getTalbeData()
        };
        reader.readAsBinaryString(this.selectedFile);

    }
    private async loadLastKat() {
        await axios.get(`/api-py/get-dict-doh-childs-by-parent/0/${this.curYear}/${this.curRegion}`).then(resp => {
            if (resp.status === 200) {
                let maxKat = 0
                for (const el of resp.data) {
                    if (el.kat > maxKat) {
                        maxKat = el.kat
                    }
                }
                this.lastKat = maxKat
            }
        }).catch(error => {})
    }

    private makeToast(variant: any, title: string, tostbody: any) {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            toaster: 'b-toaster-top-center',
            autoHideDelay: 5000,
            appendToast: true
        });
    }

}
